// src/layouts/users/data/usersTableData.js
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import AddUserModal from "components/AddUserModal";
import axios from "axios";
import Swal from "sweetalert2";
import { Person as PersonIcon } from "@mui/icons-material"; // أضف هذا الاستيراد
const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: theme.palette.success.main,
    "&:hover": {
      backgroundColor: theme.palette.success.light,
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: theme.palette.success.main,
  },
}));
const Author = ({ name, email, image }) => (
  <MDBox display="flex" alignItems="center" gap={1}>
    <MDAvatar src={image} alt={name} />
    <MDTypography variant="caption" color="text" fontWeight="medium">
      {name}
    </MDTypography>
  </MDBox>
);
const Status = ({ isActive }) => (
  <MDBox
    width="100%"
    height="100%"
    bgcolor={isActive ? "success.main" : "error.main"}
    borderRadius="lg"
    p={1}
    display="flex"
    alignItems="center"
    justifyContent="center"
  >
    <MDTypography variant="caption" color="text" fontWeight="medium">
      {isActive ? "مفعل" : "معطل"}
    </MDTypography>
  </MDBox>
);

export default function myTransctionWalletTableData(transactions) {
  return {
    columns: [
      { Header: "رقم العملية", accessor: "id", align: "center" },
      { Header: "المرسل", accessor: "from", align: "center" },
      { Header: "المستلم", accessor: "to", align: "center" },
      { Header: "المبلغ", accessor: "amount", align: "center" },
      { Header: "النوع", accessor: "type", align: "center" },
      { Header: "الحالة", accessor: "status", align: "center" },
      { Header: "التاريخ", accessor: "created_at", align: "center" },
    ],
    rows: transactions.map((tx) => {
      // تحديد نوع العملية بناءً على type
      let type = "-";
      if (tx.transactions && tx.transactions[0]) {
        type =
          tx.transactions[0].type === "out"
            ? "صادرة"
            : tx.transactions[0].type === "in"
            ? "واردة"
            : "-";
      }
      return {
        id: tx.id,
        from: tx.from_wallet?.user?.name || "-",
        to: tx.to_wallet?.user?.name || "-",
        amount: tx.amount,
        type,
        status:
          tx.status === "pending" ? (
            <span style={{ color: "#e0b15a", fontWeight: "bold" }}>قيد المعالجة</span>
          ) : tx.status === "completed" ? (
            <span style={{ color: "#43cea2", fontWeight: "bold" }}>مكتمل</span>
          ) : tx.status === "rejected" ? (
            <span style={{ color: "#e57373", fontWeight: "bold" }}>مرفوض</span>
          ) : (
            tx.status
          ),
        created_at: tx.created_at ? new Date(tx.created_at).toLocaleString("ar-EG") : "-",
      };
    }),
  };
}
